<div class="container">
  <Label style="font-weight:bold ;letter-spacing: 0.002em;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  padding-bottom: 2rem;">SwiftChat Business Terms of Service</Label>
  <div class="dialog-box">
    <p style="font-weight:bold ;">1. Introduction</p>
    a. This SwiftChat Business Terms of Services and related policies and documentation (“Business Terms” or
    “Agreement”) set forth the legally binding terms and conditions your access to and use of SwiftChat and related
    products and services that are ordered by Company under an Order Form or online purchasing portal, or provided to
    Company under a free trial, and made available online by ConveGenius Digital India Solutions Private Limited
    (collectively “ConveGenius”, “us”, “our”, or “we”).

    b. The “Company”, “Business”, “you”, “your” shall refer to any natural person and/or any legal entity, its
    authorized users who agree to these Business Terms by downloading or using the Business Services.

    c. Business Services” here refers to our products and services, applications, features, Bots, SwiftSpaces, Bot APIs
    designed and developed for Businesses on SwiftChat.

    d. By creating the SwiftChat Business Manager Account with us and accessing the Business Services, you are accepting
    these Business Terms (on behalf of yourself or the entity that you represent), and you represent and warrant that
    you have the right, authority, and capacity to enter into these Business Terms (on behalf of the the entity that you
    represent). If you do not agree with all of the provisions of these Terms, do not access and/or use the Business
    Services.

    e. Modifications to these Business Terms: From time to time, we may modify these. Your use of the Services following
    any such modification constitutes your agreement to follow and be bound by the Terms so modified. We will use
    reasonable efforts to notify Company of the changes through communications via Company’s Account, email or other
    means.

    f. All definitions used in these Business Terms are provided here and here.

    g. The “Effective Date” of the Business Terms of is the date which is the earlier of (a) Company’s initial access to
    any Business Services through any online registration, downloading and initiating the integration process or (b) the
    effective date of any Order Form, as applicable, referencing these Business Terms or (c) by clicking a box
    indicating explicit acceptance of these Terms. This Agreement will govern Company’s initial access on the Effective
    Date as well as any future accesses made by Company that reference these Terms.

    In consideration of the terms and conditions set forth below, the Parties agree as follows:

    <p style="font-weight:bold ;">2. Additional Terms and Policies</p>

    a. These Business Terms incorporate by reference (in general and specifically where stated) the following policies
    and documents:

    i. SwiftChat Bot API Integration Terms

    ii. SwiftChat User Data Processing Terms

    iii. Any Service Level Terms for usage of the Business Services

    iv. SwiftChat Content Policy

    v. SwiftChat Child Protection policy

    vi. SwiftChat Brand Guidelines

    vii. SwiftChat Intellectual Property Policy

    viii. SwiftChat Commerce Policy

    To the extent that any of the additional terms and policies conflict with these Business Terms, the additional terms
    and policies will govern.

    <p style="font-weight:bold ;">3. Creation of SwiftChat Business Manager Account</p>

    a. To access the Business Services, you must create a SwiftChat Business Manager Account which allows you to get
    access to the Business Services.

    b. You represent and warrant that you: (a) will use our Business Services solely for business, commercial, and
    authorized purposes, and not for personal use (b) will only provide registration information associated with your
    business; (c) are authorized to enter into these Business Terms and above 18 years old and (d) have not been
    previously suspended or removed from creating Company Accounts or accessing the Business Services or engaged in any
    activity that could result in
    suspension or removal.

    c. You represent and warrant that: (a) all required registration information and documentation you submit is
    truthful and accurate; (b) you will maintain the accuracy of such information. We have the right to seek
    documentation from you as part of their KYC process from time to time. Any refusal or inordinate delay in submitting
    the documents/information or resulting violation of this section allows us to suspend your access to the Business
    Manager Account or terminate your Account in accordance with the Termination Section.

    d. You agree to keep your Business Manager Account information current, accurate and complete so that we may send
    notices, statements and other information to you via email or through the Account, which notifications will be
    subject to this Agreement and the Privacy Policy. You are responsible for maintaining the confidentiality of your
    Business Manager Account login information and are fully responsible for all activities that occur under your
    Company Account. You agree to immediately notify us of any unauthorized use, or suspected unauthorized use of your
    Business Manager Account or any other breach of security. We shall not be held liable for any loss or damage arising
    from your failure to comply with the above requirements.

    e. You agree to use the Business Services in compliance with (a) our technical and product documentation and any
    other related documentation provided by us regarding use of our Bot APIs (collectively “Business Services
    Documentation”) (b) the SwiftChat User Data Processing Terms and (c) all other additional terms and policies
    incorporated by reference to these Business Terms.

    f. Third Parties managing the access to Business Services on behalf of Company.

    i. In the instance that you retain a third party as your service provider to manage your access to the Business
    Services, you represent and warrant that such third party will only process data pursuant to your instructions and
    authorization, and subject to a written agreement that obligates such data processing to be in compliance with these
    Business Terms including being as protective of any personal data of the Users. You represent that you are solely
    and fully liable for all acts and omissions by such third parties authorized by you.

    <p style="font-weight:bold ;">4. Use of our Bot APIs</p>

    a. The Bot APIs have been created to allow Businesses to integrate their existing business solutions in the form of
    chat bots (“Merchant Bots”) to SwiftChat. This allows you to launch and integrate their existing Merchant Bots with
    SwiftChat and access SwiftChat to send messages, or use other available features to interact with the Users who are
    currently using SwiftChat.

    b. Customers for the purpose of the Business Terms refer to such Users of SwiftChat who expressly opt-in to receive
    messages and interact with the Merchant Bots. Such Customers are governed by the SwiftChat Terms of Service and
    Privacy Policy.

    c. To access the Bot APIs, you must create a SwiftChat Business Manager Account which allows you to get access to
    the Business Services documentation and process to complete the integration of the Merchant Bots with SwiftChat.

    d. The usage of Bot APIs by the Company shall also be governed by additional SwiftChat Bot API Integration Terms
    available here which are incorporated by reference to these Business Terms.

    <p style="font-weight:bold ;">5. Fees, Taxes, Invoicing, and Payment (if and when applicable)</p>

    a. Any fee schedule applicable as part of these Business Terms will be provided to you through your
    Business Manager Account.

    b. Both Parties shall individually be responsible to pay all fees and taxes required by applicable laws in
    connection with performance of any services or invoices raised as part of these Business Terms.

    <p style="font-weight:bold ;">6. Ownership & Licenses</p>

    a. All titles and any intellectual property rights to the Business Services and Business Services Documentation or
    its modifications and amendments belong to us. We own all copyrights, trademarks, domains, logos, trade dress, trade
    secrets, patents, and other intellectual property rights associated with the Business Services and Business Services
    Documentation. Except as expressly stated herein, these Business Terms do not grant Company any intellectual
    property rights to the Business Services and Business Services Documentation.

    b. Company undertakes that it retains all titles and intellectual property rights over its Merchant Bots.

    c. License by Company: Our Business Services enable you to reach out and interact with our Users and share to
    create, post, store, send, and receive content, such as text, images, videos, and other materials, including Company
    trademarks, logos, slogans, and other proprietary materials (collectively, “Company Content or Content”). You grant
    us and our subsidiaries and affiliates a worldwide, non-exclusive, sub-licensable, and transferable license to use,
    reproduce, modify, adapt, publish, translate, distribute or display the Company Content on SwiftChat that you send
    or receive through the Business Services. This license to use the Content is for the purposes of providing,
    operating, developing, promoting, updating, and improving the Business Services and researching and developing new
    services, features, or uses. You represent and warrant that you have all rights necessary to grant us the license to
    Company Content, and that our use of it will not violate any intellectual property right of any person or entity.
    Except for the license you grant to us above, you retain all ownership and other rights in and to the Company
    Content.

    d. Your provision to provide your Content to the Users (or Customers as applicable) is also governed under SwiftChat
    Content Policy and Child Protection Policy. Company agrees to use the Business Services while adhering to the terms
    and conditions of the Policies mentioned herein which are incorporated by reference here.

    e. Our License to you: Subject to your compliance with these Business Terms, we grant you a limited, revocable,
    non-exclusive, non-sublicensable, and non-transferable license to use our Business Services and get access to the
    Users (or Customers as applicable) solely as authorized in these Business Terms.

    f. Both Parties consent to use the other Party’s name, logo and/or trademark, in connection with certain promotional
    materials that the other Party may disseminate to the public within the context of these Business Terms. The
    promotional materials may include, but are not limited to, brochures, video tape, website, press releases, social
    media collaterals, advertising in newspaper and/or other periodicals or magazines, and any other materials relating
    to marketing and promotional efforts, specific to the subject matter of these Business Terms. The Company
    specifically agrees to use our trademarks solely as set forth in our Brand Guidelines incorporated here by
    reference.

    <p style="font-weight:bold ;">7. Use of Business Services and Business Services Documentation</p>

    a. Company agrees to use the Business Services and the Business Services Documentation in accordance with these
    Business Terms only and agrees not to use or permit use of Business
    Services for any purpose that may:

    i. constitute an infringement of intellectual property or other proprietary rights; or
    ii. otherwise violate applicable laws, ordinances or regulations.
    iii. violates the term of this Agreement

    b. We may use tools, scripts, software, and utilities (collectively, the “Service Tools”) to monitor and administer
    the Business Services. The Service Tools will not collect or store any Company Content except as necessary to
    provide the Business Services or troubleshoot service requests or other problems in the Business Services.
    Information collected by the Service may also be used to assist in managing our product and service portfolio and to
    help us address deficiencies (if any) in its services.

    c. We may:

    i. compile statistical and other information related to the performance, operation and use of the Business Services
    and
    ii. use data collected via the Business Services in aggregated form for security and operations management, to
    create statistical analyses, and for research and development purposes (together “Service Analyses”).

    d. Such Service Analyses will not incorporate any Confidential Information in a form that could serve to identify
    the Company or any individual, and Service Analyses do not constitute personal data. We retain all intellectual
    property rights in Service Analyses.

    <p style="font-weight:bold ;">8. Acceptable Use of the Business Services</p> Company will not (nor assist others to)
    violate any applicable law, contract, intellectual property, or other third-party right, and Company is solely
    responsible for its conduct while using the Business Services. Company must not directly, indirectly, or through
    automated or other means: (a) use the Business Services for personal, family, or household purposes; (b) engage in
    any harassing, threatening, intimidating, predatory, or stalking conduct; (c) impersonate or register on behalf of
    any person or entity or otherwise misrepresent your affiliation with a person or entity, perpetrate fraud, or
    publish falsehoods or misleading statements; (e) collect information of or about Users in any impermissible or
    unauthorized manner; (f) use the Business Services other than for their intended purpose or interfere with, disrupt,
    negatively affect, or inhibit other users; (g) damage, disable, overburden, or impair the Business Services; (h)
    send, distribute, or post spam, unsolicited electronic communications, chain letters, pyramid schemes, or illegal or
    impermissible communications; (i) post, upload, or share any content which is unlawful, libelous, defamatory,
    obscene, pornographic, indecent, lewd, suggestive, harassing, threatening, invasive of privacy or publicity rights,
    abusive, inflammatory, fraudulent, or is in our sole judgment objectionable; (j) encourage or provide instructions
    for a criminal offense; (k) distribute any viruses, corrupted data, or other harmful, disruptive, or destructive
    files or content; (l) bypass, ignore, or circumvent instructions in our robots.txt file or any measures we employ to
    prevent or limit access to any part of our Business Services, including content-filtering techniques; or (m) expose
    us to any type of harm or liability.

    <p style="font-weight:bold ;">9. Data Privacy and Protection</p>

    a. You may only use our Business Services if you have ensured that your use of our Business Services complies with
    all legal and regulatory requirements that are applicable to you as per your requirement.

    b. You must provide all necessary data disclosures and notices (such as maintaining a privacy policy or labelling
    marketing messages).

    c. You must also secure all necessary rights, consents, and permissions to share its customers’’ contact and other
    personal data with us and/or before collecting the User’s contact and other personal data from SwiftChat.

    d. Users may block Company’s messages as spam, or notify us that the Company is otherwise violating our terms and
    policies. We will then take appropriate action, which may result in us suspending or terminating your use of our
    Business Services.

    e. The access of User (or Customers as applicable) data that you collect from is governed by SwiftChat API
    Integration Terms and SwiftChat User Data Processing Terms incorporated here by reference.

    f. Security Measures: we will allow authorized individuals acting on behalf of Company to access and use the
    Business Services for purposes authorized under these Business Terms. Company is responsible for all activities
    occurring under its account. Company must: (a) maintain the security of its account credentials; (b) keep its
    devices and the account safe and secure; (c) prevent unauthorized use of or access to our Business Services; and (d)
    immediately notify us if Company discovers or suspects any security breaches related to our Business Services or if
    Company discovers or suspects any such unauthorized access or use. We implement and follow generally recognized
    industry standards and best practices for data and information security to protect our and the Company’s data,
    network, and systems from unauthorized access, use, or copying. Company must promptly delete any user’s information
    it obtained via our Business Services if we determine, in our reasonable discretion, that Company breached its
    obligation to protect and prevent unauthorized use or access to its devices, account, or systems, breached these
    Business Terms, or if these Business Terms are terminated for any reason.

    <p style="font-weight:bold ;">10. Non-Disclosure</p>

    a. By virtue of these Business Terms, the Parties may have access to Confidential Information. Subject to the
    Termination section, the Party which receives the Confidential Information agrees not to disclose the other’s
    Confidential Information which is being disclosed by the other Party.

    b. A Party’s Confidential Information shall not include information that:

    i. is or becomes a part of the public domain through no act or omission of the other party;
    ii. was in the other party’s lawful possession prior to the disclosure and had not been obtained by the other party
    either directly or indirectly from the disclosing party;
    iii. is lawfully disclosed to the other party by a third party without restriction on the disclosure; or
    iv. is independently developed by the other party.

    c. Each party may disclose Confidential Information only to those employees, agents or subcontractors who are
    required to protect it against unauthorized disclosure in a manner no less protective than required under this
    Agreement. This clause will survive the termination of this Agreement.

    d. Confidential Information as per these Business Terms refer the Business Services, Business Services
    Documentation, content and services available on SwiftChat, Company Content, Merchant Bots, any non-public
    information relating to the features and functionality of SwiftChat and Business Services, and all information
    clearly identified as confidential at the time of disclosure.

    <p style="font-weight:bold ;">11. Term and Termination</p>

    a. Term: These Business Terms are effective from the date you create the Business Manager Account and will continue
    until terminated as permitted herein.

    b. Termination for Convenience: Either Party may terminate these Business Terms without cause, at any time, by
    providing prior written notice of 60 (sixty) days to the other Party.

    c. Suspension and Termination: We may immediately suspend your access to the Business Services or terminate these
    Terms if you breach this Agreement (including any terms or policies incorporated by reference), or if we deem such
    action necessary to comply with applicable laws or to prevent harm to the security, stability, availability, or
    integrity of SwiftChat. Termination will result in termination of your access to the Business Services. Upon
    termination, we will remove your access to the Business Services.

    d. Effect of Termination: Upon any termination or expiration of this Agreement: (a) you must immediately cease using
    the Business Services (b) at the disclosing party’s request, the receiving party will promptly return or delete any
    of the disclosing party’s confidential information in its possession.

    <p style="font-weight:bold ;">12. Warranties, Disclaimers and Exclusive remedies</p>

    a. Company agrees that they will use the Business Services at their own risk and subject to the following
    disclaimers.

    b. We do not undertake that:

    i. Business Services will be error-free or uninterrupted, or that we will correct all services errors;
    ii. Business Services will meet the Company’s requirements, specifications or expectations. The Company acknowledges
    that we do not control the transfer of data over communications facilities, including the internet, and that usage
    of the Business Services and transfer of data may be subject to limitations, delays, and other problems inherent in
    the use of such communications facilities;
    iii. We are not responsible for any delays, delivery failures, or other damage resulting from such problems. We are
    not responsible for any issues related to the performance, operation or Security of the Merchant Bots that arise
    from the Company Content or third party content.

    c. For any breach of these Terms by us, the Company’s exclusive remedy and shall be the correction of the deficient
    services that caused the breach of this Terms by us, or, if we cannot substantially correct the deficiency in a
    commercially reasonable manner, the Company may terminate these Terms on 14 days’ written notice and we shall have
    no further liability to the Company.

    d. To the extent not prohibited by law, any warranties provided under these Terms are exclusive and all other
    warranties or conditions, whether express or implied, are expressly excluded, including for software, hardware,
    systems, networks or environments or for merchantability, satisfactory quality and fitness for a particular purpose.

    <p style="font-weight:bold ;">13. Miscellaneous</p>

    a. We may update these Terms including any of the additional terms, policies, or documentation incorporated into
    this Agreement by reference. Unless otherwise required by law, we will notify you before we make such updates. By
    continuing to use the Business Services and interacting with Users after such notice, you consent to such update.

    b. Indemnity: Company agrees to indemnify us from and against any losses arising out of or in connection with any
    claim or allegation that any information, design, specification, instruction, software, service, data, hardware, or
    material furnished by the Company infringes any applicable laws or the rights (including, without limitation,
    intellectual property rights) of a third party.

    c. Limitation of liability: Neither party shall be liable for any indirect, incidental, special, punitive, or
    consequential damages, or any loss of revenue or profits, data, or data use. Save in respect of liability which
    cannot be excluded as a matter of law, we exclude all liability to the Company whether in contract or tort, for any
    claim which arises during or as a result of the Company’s use of the Business Services under these Terms.

    d. Governing Law: This Agreement, as well as any claim that might arise between you and us, are governed by and
    construed in accordance with the laws of India without giving effect to their principles of conflicts of law. Any
    claim or cause of action arising out of or relating to this Agreement must be commenced exclusively in the courts of
    New Delhi.

    e. Entire Agreement: These Business Terms and any additional terms agreed upon between you and us comprise the
    entire agreement between the parties regarding the use of the Business Services, and unless expressly agreed upon
    otherwise between the parties, supersedes any prior representations or agreements.

    f. Waiver and Severability: Failure to enforce a provision will not be deemed a waiver; waivers must be in writing
    and signed by the waiving party. If any provision of this Agreement is adjudged by a court of competent jurisdiction
    to be unenforceable, invalid, or otherwise contrary to law, such provision will be interpreted so as to best
    accomplish its intended objectives and the remaining provisions of this Agreement will remain in full force and
    effect.

    g. Publicity: Any press release, publicity, or public announcement about the parties’ relationship requires the
    prior written approval of both parties.

    h. Assignment: Neither party may assign this Agreement or its rights or obligations under this Agreement without the
    prior written consent of the other party, except that we may assign this Agreement without consent to their
    subsidiaries or in connection with a merger, reorganization, acquisition, or other transfer of all or substantially
    all of its assets or voting securities. Subject to the foregoing, this Agreement will bind and inure to the benefit
    of each party’s permitted successors and assigns.

    i. Independent Contractor: The parties are independent contractors. No agency, partnership, joint venture, or
    employment is created as a result of this Agreement and neither party has authority to bind the other.

    j. Notices. Any notice under this Agreement must be in writing.

    For SwiftChat:
    Email: legal@swiftchat.ai
    Postal address:
    CONVEGENIUS DIGITAL INDIA SERVICES PRIVATE LIMITED
    B-52, Sector 63, NOIDA, Gautam Buddha Nagar, Uttar Pradesh, 201301

    For Company:
    As per the details provided in the Company verification or KYC forms circulated by us.

    k. Force Majeure. Neither party will be liable to the other for any delay or failure to perform any obligation under
    this Agreement (except for a failure to pay fees) if the delay or failure is due to unforeseen events that occur
    after the signing of this Agreement and that are beyond the reasonable control of such party, such as a strike,
    blockade, war, act of terrorism, riot, natural disaster, failure or diminishment of power, telecommunications, data
    networks, or services, or refusal of a license or authorization by a government agency or entity.

    You can reach our customer support team to address any of your queries or complaints at
    support@swiftchat.ai.
  </div>
  <div class="text-center py-3">
    <button class="btn add btn-outline-primary mx-3 my-1" (click)="reject()">Reject</button>
    <button class="btn add btn-primary mx-3 my-1" (click)="accept()">Accept</button>
  </div>
</div>
